import React, {Fragment} from 'react';
import PersonIcon from '@material-ui/icons/Person'
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles(theme => ({
	icon: {
		verticalAlign: 'bottom',
		paddingRight: 4,
	},
}), {name: 'EvoAppsUserLabel'});
export const EvoAppsUserLabel = ({user, defaultUser}) => {
	const classes = useStyles();
	// return user.longUsername + " (" + user.text + ", " + user.username + ") " + user.userGroup.id;
	const {username, longUsername, text, userGroup} = user;
	return (
		<Fragment>
			{
				username === defaultUser.username && userGroup.id === defaultUser.userGroup.id &&
				<PersonIcon fontSize={'small'} className={classes.icon}/>
			}
			{
				longUsername +
				(username !== longUsername ? (" [" + username + "]") : "") +
				" - " + text +
				" (" + userGroup.id + " - " + userGroup.description + ")"
			}
		</Fragment>
	);
};